es-resize-observer {
    display: block;
}
